export const authOptions = {
    client_id: process.env.AUTH_CLIENT_ID || '',
    url: process.env.AUTH_CLIENT_URL || '',
    redirect_url: window.location.origin,
    scope: 'identity:',
    theme: 'goto',
}
